import { Box } from "@mui/material";
import logo from "../../../assets/rerepo_logo.svg";

/**
 * サイドバーに置くときのロゴの高さ（px）。下に「リレポ」の文字が入る分だけ高い図案のため、
 * 欧文（R.E. REPO）の字の高さが R.E.ASSIST のロゴ（14px）とそろう値にする。
 */
export const REREPO_LOGO_HEIGHT = 22;

interface Props {
  /** 高さ（px）。 */
  height: number;
}

/**
 * R.E.REPO のロゴ（SVG。ベクターのため、どの画面密度でも輪郭が崩れない）。
 * 図案と色は変えず、白地の上にだけ置く。
 */
export const RerepoLogo: React.FC<Props> = ({ height }) => (
  <Box
    component="img"
    src={logo}
    alt="R.E.REPO"
    sx={{
      display: "block",
      height,
      width: "auto",
      maxWidth: "100%",
      flexShrink: 0,
    }}
  />
);
